import { mutator } from 'satcheljs';
import getStore from '../store/store';
import { updateBirthdayCalendarInitialState } from '../../actions/internalActions';

/**
 * Called when there is a change in the birthday calendar enabled option
 */

export default mutator(updateBirthdayCalendarInitialState, actionMessage => {
    let optionState = getStore();
    optionState.birthdayCalendarEnabledInitial = actionMessage.birthdayCalendarEnabled;
});
